export default __webpack_public_path__ + "static/media/history_1960_02.b715fb3e.png";